
<template>
  <div class="card border-inside">
    <div>
      <transition name="slide-fade">
        <div class="loading-integreat" v-if="isLoadingPage">
          <div class="initial-load-animation">
            <div class="linkedin-image"></div>
            <div class="loading-bar">
              <div class="blue-bar"></div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="level title">
          <p class="is-size-4 has-text-weight-semibold is-padding-sm">
            Business Credit Score
          </p>
        </div>
        <hr />
        <div>
          <div class="is-padding-top-s">
            <div
              class="box-border width-max is-flex is-align-center pd-20 is-justify-center"
            >
              <div class="is-align-center is-flex is-flex-column">
                <VueSvgGauge
                  :start-angle="-90"
                  :end-angle="90"
                  :value="totalScore * 2"
                  :max="9 * 2"
                  :min="0"
                  :separator-step="3"
                  :separator-thickness="3"
                  :scale-interval="2"
                  :inner-radius="50"
                >
                </VueSvgGauge>
                <span class="percentOfScore has-text-weight-semibold"
                  ><ICountUp
                    :delay="delay"
                    :endVal="(totalScore * 100) / 9"
                    :options="options"
                    @ready="onReady()"
                  />%</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP, HTTPDynamic } from "../axios.js";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import { VueSvgGauge } from "vue-svg-gauge";
import ICountUp from "vue-countup-v2";
import { covertInputData } from "@/service/dynamic";

export default {
  data() {
    return {
      countDate: null,
      inCome: null,
      person: null,
      timeInBatch: null,
      presentDateTime: null,
      currentYear: null,
      TotalTimeInBatch: null,
      TotalRunBusiness: null,
      isLoadingPage: null,
      TotaltaskAndActivity: null,
      busLevel: null,
      totalScore: null,
      delay: 2000,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: "",
      },
    };
  },
  components: {
    ThailandAutoComplete,
    VueSvgGauge,
    ICountUp,
  },
  computed: {
    tokenForm() {
      return this.$store.state.tokenForm;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
    businessLevel() {
      return this.$store.state.businessLevel;
    },
    businessType() {
      return this.$store.state.businessType;
    },
    user() {
      return this.$store.state.user;
    },
    batch() {
      return this.$store.state.batch;
    },
    batchLists() {
      let batchSort = [];
      if (
        typeof this.$store.state.batchLists === "undefined" ||
        this.$store.state.batchLists === null ||
        this.$store.state.batchLists.length === 0
      ) {
        batchSort = [];
      } else {
        batchSort = this.$store.state.batchLists.sort((a, b) => {
          const modifier = -1;
          if (a.createdAt > b.createdAt) return 1 * modifier;
          return 0;
        });
      }
      return batchSort;
    },
    dataCountry() {
      return this.$store.state.dataCountry;
    },

    token() {
      return this.$store.state.token;
    },
    taskOverdue() {
      let filter = this.$store.getters.tasks.filter(
        (item) =>
          item.status === 4 &&
          (item.finishProcessDate === "" ||
            item.finishProcessDate === null ||
            typeof item.finishProcessDate === "undefined")
      );
      return filter.length;
    },
    taskDone() {
      let filter = this.$store.getters.tasks.filter(
        (item) =>
          item.finishProcessDate !== "" &&
          item.finishProcessDate !== null &&
          typeof item.finishProcessDate !== "undefined"
      );
      return filter.length;
    },
    tasksAll() {
      return this.$store.getters.tasks;
    },
    activitysAll() {
      return this.$store.state.activitysAll;
    },
    businessLevel() {
      return this.$store.state.businessLevel;
    },
    lastUpdateFormVer() {
      return this.$store.state.lastUpdateFormVer;
    },
  },
  created() {
    this.fethFormBatch();
  },
  methods: {
    onReady(instance, CountUp) {
      if (instance != "" && typeof instance != "undefined") {
        const that = this;
        instance.update(that.endVal + 100);
      }
    },
    getBusLevel(data) {
      this.busLevel = data.name;
      return data.name;
    },
    CalCreditScoring() {
      //   --------------------------------------- การเติบโตของธรุกิจ
      let getScoreRunBusiness = 0,
        getScoreApprove = 0,
        getScoreInCome = 0,
        getScoretaskOverdue = 0,
        getScoretaskDone = 0,
        getScoreAllTaskActivity = 0,
        getScoreBatch = 0,
        getScoreTimeinBatch = 0,
        getScorePerson = 0,
        getScoreLevelBus = 0;

      if (this.TotalRunBusiness < "1") {
        getScoreRunBusiness = getScoreRunBusiness + 0;
      } else if (this.TotalRunBusiness > "1" && this.TotalRunBusiness < "3") {
        getScoreRunBusiness = getScoreRunBusiness + 1;
      } else if (this.TotalRunBusiness > "3" && this.TotalRunBusiness < "5") {
        getScoreRunBusiness = getScoreRunBusiness + 2;
      } else {
        getScoreRunBusiness = getScoreRunBusiness + 3;
      }
      //console.log('คะแนนของระยะเวลาดำเนินธรุกิจ',getScoreRunBusiness)
      if (this.taskApproveAmountInVisible() < 100000) {
        getScoreApprove = getScoreApprove + 0;
      } else if (
        this.taskApproveAmountInVisible() > 300000 &&
        this.taskApproveAmountInVisible() < 500000
      ) {
        getScoreApprove = getScoreApprove + 1;
      } else if (
        this.taskApproveAmountInVisible() > 500000 &&
        this.taskApproveAmountInVisible() < 700000
      ) {
        getScoreApprove = getScoreApprove + 2;
      } else if (
        this.taskApproveAmountInVisible() > 700000 &&
        this.taskApproveAmountInVisible() < 1000000
      ) {
        getScoreApprove = getScoreApprove + 3;
      } else if (
        this.taskApproveAmountInVisible() > 1000000 &&
        this.taskApproveAmountInVisible() < 300000
      ) {
        getScoreApprove = getScoreApprove + 4;
      } else {
        getScoreApprove = getScoreApprove + 5;
      }
      //console.log('คะแนนของจำนวนเงินที่ได้รับอนุมัติทุน',getScoreApprove)
      if (this.income == "0") {
        getScoreInCome = getScoreInCome + 0;
      } else if (this.inCome > "50000" && this.inCome < "100000") {
        getScoreInCome = getScoreInCome + 1;
      } else if (this.inCome > "100000" && this.inCome < "200000") {
        getScoreInCome = getScoreInCome + 2;
      } else if (this.inCome > "200000" && this.inCome < "500000") {
        getScoreInCome = getScoreInCome + 3;
      } else if (this.inCome > "500000" && this.inCome < "1000000") {
        getScoreInCome = getScoreInCome + 4;
      } else if (this.inCome > "1000000") {
        getScoreInCome = getScoreInCome + 5;
      } else if (this.inCome > "-50000" && this.inCome < "-100000") {
        getScoreInCome = getScoreInCome - 1;
      } else if (this.inCome > "-100000" && this.inCome < "-200000") {
        getScoreInCome = getScoreInCome - 2;
      } else if (this.inCome > "-200000" && this.inCome < "-500000") {
        getScoreInCome = getScoreInCome - 3;
      } else if (this.inCome > "-500000" && this.inCome < "-1000000") {
        getScoreInCome = getScoreInCome - 4;
      } else if (this.inCome > "-1000000") {
        getScoreInCome = getScoreInCome - 5;
      }
      //console.log('คะแนนของรายได้',getScoreInCome)
      //   --------------------------------------- การดำเนินงานของธุรกิจ
      if (this.taskOverdue == "0") {
        getScoretaskOverdue = getScoretaskOverdue + 0;
      } else if (this.taskOverdue >= "1") {
        getScoretaskOverdue = getScoretaskOverdue - 1;
      } else if (this.taskOverdue >= "3") {
        getScoretaskOverdue = getScoretaskOverdue - 2;
      } else if (this.taskOverdue >= "6") {
        getScoretaskOverdue = getScoretaskOverdue - 3;
      } else if (this.taskOverdue >= "9") {
        getScoretaskOverdue = getScoretaskOverdue - 4;
      } else if (this.taskOverdue >= "12") {
        getScoretaskOverdue = getScoretaskOverdue - 5;
      }
      //console.log('คะแนนของงานที่ล่าช้า',getScoretaskOverdue)
      if (this.taskDone == "0") {
        getScoretaskDone = getScoretaskDone + 0;
      } else if (this.taskDone >= "1") {
        getScoretaskDone = getScoretaskDone + 1;
      } else if (this.taskDone >= "3") {
        getScoretaskDone = getScoretaskDone + 2;
      } else if (this.taskDone >= "6") {
        getScoretaskDone = getScoretaskDone + 3;
      } else if (this.taskDone >= "9") {
        getScoretaskDone = getScoretaskDone + 4;
      } else if (this.taskDone >= "12") {
        getScoretaskDone = getScoretaskDone + 5;
      }
      //console.log('คะแนนของงานที่ทำตามแผนงาน',getScoretaskDone)
      this.TotaltaskAndActivity =
        this.activitysAll.length + this.tasksAll.length;
      if (this.TotaltaskAndActivity == "0") {
        getScoreAllTaskActivity = getScoreAllTaskActivity + 0;
      } else if (this.TotaltaskAndActivity >= "1") {
        getScoreAllTaskActivity = getScoreAllTaskActivity + 1;
      } else if (this.TotaltaskAndActivity >= "6") {
        getScoreAllTaskActivity = getScoreAllTaskActivity + 2;
      } else if (this.TotaltaskAndActivity >= "10") {
        getScoreAllTaskActivity = getScoreAllTaskActivity + 3;
      }
      //console.log('คะแนนของจำนวนกิจกรรมและแผนทั้งหมด',getScoreAllTaskActivity)
      if (this.batchLists.length == 1) {
        getScoreBatch = getScoreBatch + 1;
      } else if (this.batchLists.length == 2) {
        getScoreBatch = getScoreBatch + 2;
      } else if (this.batchLists.length >= 4) {
        getScoreBatch = getScoreBatch + 3;
      }
      //console.log('คะแนนของจำนวนโครงการทั้งหมดที่เข้าร่วม',getScoreBatch)
      if (this.TotalTimeInBatch < "1") {
        getScoreTimeinBatch = getScoreTimeinBatch + 0;
      } else if (this.TotalTimeInBatch > "1" && this.TotalTimeInBatch < "3") {
        getScoreTimeinBatch = getScoreTimeinBatch + 1;
      } else if (this.TotalTimeInBatch > "3") {
        getScoreTimeinBatch = getScoreTimeinBatch + 2;
      }
      //console.log('คะแนนของระยะเวลาที่อยู่ในโครงการ',getScoreTimeinBatch)
      if (this.person > "3") {
        getScorePerson = getScorePerson + 1;
      } else {
        getScorePerson = getScorePerson + 2;
      }
      //console.log('คะแนนของจำนวนบุคคลากรที่อยู่ในองค์กร',getScorePerson)

      if (
        this.busLevel == "มีแนวคิดไอเดีย" &&
        this.busLevel == "มีผลิตภัณฑ์ต้นแบบแล้ว"
      ) {
        getScoreLevelBus = getScoreLevelBus + 1;
      } else if (
        this.busLevel == "มีการทำข้อตกลงร่วมกับคู่ค้าทางธุรกิจแล้ว" &&
        this.busLevel == "ผลิตภัณฑ์หรือบริการมีการทดสอบกับลูกค้าแล้ว"
      ) {
        getScoreLevelBus = getScoreLevelBus + 2;
      } else {
        getScoreLevelBus = getScoreLevelBus + 3;
      }
      this.totalScore =
        (getScoreRunBusiness + getScoreApprove + getScoreInCome) / 3 +
        (getScoretaskOverdue +
          getScoretaskDone +
          getScoreAllTaskActivity +
          getScoreBatch +
          getScoreTimeinBatch) /
          5 +
        (getScorePerson + getScoreLevelBus) / 2;

      //console.log('okokokokookook',this.totalScore)
    },
    dateFomatNotTime(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "-";
      } else {
        res = this.$moment(date).format("Y");
      }
      return res;
    },
    taskApproveAmountInVisible() {
      let amount = 0;
      this.$store.getters.taskInVisible.map((item) => {
        if (
          item.approveAmount !== null &&
          typeof item.approveAmount !== "undefined" &&
          item.approveAmount !== ""
        ) {
          amount = amount + item.approveAmount;
        }
      });
      return amount;
    },
    async fethFormBatch() {
      let data = {
        batchId: this.batch._id,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`get/form/on/batch`, data)
        .then((res) => {
          //console.log("get/form/on/batch", res);
          this.isLoadingPage = false;
          if (res.data.success) {
            if (res.data.obj.listComponents.length !== 0) {
              if (
                res.data.obj.listComponents[0].componentId.type === "template"
              ) {
                this.fetchDataForm(
                  res.data.obj.listComponents[0].componentId.id
                );
              } else {
                this.fetchDataForm(
                  res.data.obj.listComponents[0].componentId.id
                );
              }
            }
          }
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("get/form/on/batch/error", e);
        });
    },
    async fetchDataForm(id) {
      this.isLoadingPage = true;

      let data = {
        componentId: id,
        companyId:
          this.getRule === "startup"
            ? this.user._id
            : this.userDetail.startUpId,
        roleId: this.batch._id,
        keyRequest: this.tokenForm,
      };
      //console.log("get/data/form/prod/data", data);
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/data/form/prod`, data)
        .then((res) => {
          //console.log("get/data/form/prod", res);
          if (res.data.success) {
            let obj = {};
            if (
              new Date(res.data.obj.updateDate).getTime() <
              new Date(this.lastUpdateFormVer).getTime()
            ) {
              this.obj = covertInputData(res.data.obj.data);
            } else {
              this.obj = res.data.obj.data[0].input;
            }
            this.isLoadingPage = false;
            this.countDate = this.dateFomatNotTime(
              res.data.obj.data[0].input.paidDate
            );
            this.inCome = res.data.obj.data[0].input.Income;
            this.person = res.data.obj.data[0].input.totalEmployee;

            this.timeInBatch = this.dateFomatNotTime(
              this.userDetail.contractDate
            );
            this.presentDateTime = new Date();
            this.currentYear = this.dateFomatNotTime(this.presentDateTime);
            this.TotalRunBusiness = this.currentYear - this.countDate;
            this.TotalTimeInBatch = this.currentYear - this.timeInBatch;
          } else {
            this.countDate = null;
            this.inCome = null;
            this.person = null;
            this.timeInBatch = null;
            this.isLoadingPage = false;
          }
          this.CalCreditScoring();
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("get/data/form/prod/error", e);
        });
    },
  },
};
</script>
<style scoped>
.fileCoordinator {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.mg-100 {
  margin: 100px !important;
}
.inner-text {
  height: 100%;
  width: 100%;
}
.mg-l-50 {
  margin-left: 50px !important;
}
.percentOfScore {
  margin-top: -3rem;
  font-size: 2rem;
}
</style>
